var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1710823827436,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 24577,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M801.7408 164.9152C622.6432 17.4592 355.9936 29.8496 191.5904 202.1888c-164.5056 172.4416-164.5056 447.1808 0 619.6224 164.4032 172.3392 431.0016 184.7296 610.1504 37.2736 18.2272-15.0016 19.6608-42.3936 2.9696-59.0848l-259.7888-259.7888a39.86432 39.86432 0 0 1 0-56.3712l259.7888-259.7888c16.6912-16.7424 15.2576-44.1344-2.9696-59.136zM463.5136 227.84c0-30.7712 24.9344-55.7056 55.7056-55.7056 30.7712 0 55.7056 24.9344 55.7056 55.7056s-24.9344 55.7056-55.7056 55.7056c-30.7712 0-55.7056-24.9344-55.7056-55.7056z",
    fill: "#FF623E",
    "p-id": 24578
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M709.5808 512m-55.7056 0a55.7056 55.7056 0 1 0 111.4112 0 55.7056 55.7056 0 1 0-111.4112 0Z",
    fill: "#FF623E",
    "p-id": 24579
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M876.288 514.5088m-55.7056 0a55.7056 55.7056 0 1 0 111.4112 0 55.7056 55.7056 0 1 0-111.4112 0Z",
    fill: "#FF623E",
    "p-id": 24580
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.79380bdfd491503175cee9fa3dcd0223.svg";
export { ForwardRef as ReactComponent };